import { useState } from 'react';
import { Button, Icon, Menu, MenuItem } from 'semantic-ui-react';
import { CompletedExtractionType } from '../../types';
import './styles.css';

type ExtractionHistoryPropsType = {
    completedExtractions: CompletedExtractionType[];
    className?: string;
};

const ExtractionsHistory = ({ completedExtractions, className = '' }: ExtractionHistoryPropsType) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className={className}>
            <Button
                icon="zip"
                color="green"
                onClick={() => {
                    if (completedExtractions.length) {
                        setVisible((prev) => !prev);
                    } else {
                        setVisible(false);
                    }
                }}
            />
            <Menu
                className={`extraction-history__list ${
                    visible ? 'extraction-history__list--visible' : 'extraction-history__list--hidden'
                }`}
                icon="labeled"
                inverted
                vertical
            >
                {completedExtractions.map((extraction, index) => (
                    <MenuItem key={index} href={extraction.url} target="_blank">
                        <div className="flex">
                            <Icon name="check" color="green" />
                            {extraction.userFriendlyFileName}
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default ExtractionsHistory;
